import { z } from 'zod';
import { CoreDocumentsTemplateResourceTypeSchema } from '../inputTypeSchemas/CoreDocumentsTemplateResourceTypeSchema'

/////////////////////////////////////////
// CORE DOCUMENTS TEMPLATE SCHEMA
/////////////////////////////////////////

export const CoreDocumentsTemplateSchema = z.object({
  resourceType: CoreDocumentsTemplateResourceTypeSchema,
  id: z.number().int(),
  cityId: z.number().int(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  deactivatedAt: z.coerce.date().nullable(),
  name: z.string(),
  description: z.string().nullable(),
  s3Url: z.string().nullable(),
  isPublic: z.boolean().nullable(),
})

export type CoreDocumentsTemplate = z.infer<typeof CoreDocumentsTemplateSchema>

export default CoreDocumentsTemplateSchema;
